module.exports = __webpack_public_path__ + "static/media/Btaes.5b87e51f.png";